<template>
  <div class="n-footer">
    <div class="container">
      <!-- 上传 -->
      <div class="f1">
        <a href="javascript:;">电话：010-62055714</a>
        <a href="javascript:;">地址：北京市海淀区知春路6号(锦秋国际大厦)4层A03</a>
      </div>

      <!-- 中 -->
      <div class="f1">
        <!-- <a href="https://beian.miit.gov.cn/#/Integrated/index"
          >© 2020 北京掌中空间网络科技有限公司
        </a> -->
        <!-- <a href="https://oceanengine.com/extra/legal" target="_block">
          法律声明
        </a>
        <a href="https://oceanengine.com/extra/license" target="_block"
          >营业执照
        </a> -->
        <a href="javascript:;">北京画娱天下科技有限公司</a>
      </div>
      <!-- 下 -->
      <div class="f1">
        <a href="https://www.12377.cn/">违法和不良信息举报中心</a>
        <a href="https://jbts.mct.gov.cn/">12318全国文化市场举报平台</a>
        <a href="http://www.bjjubao.org.cn/"
          >北京市互联网违法和不良信息举报中心</a
        >
      </div>
      <!-- icp -->
      <div class="f1">
        <img src="/imgs/icp.png" alt="" />
        <a href="https://beian.miit.gov.cn/#/Integrated/index"
          >京ICP备2021035661号-2</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-footer",
  props: {
    email: String,
    phone: String,
    icp: String,
    name: String,
    addr: String,
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.n-footer {
  width: 100%;
  height: 200px;
  background-color: #000;
  // margin-bottom: 60px;
  // padding-top: 30px;
  box-sizing: border-box;
  padding-top: 15px;
  box-sizing: border-box;
  clear: both;
  .container {
    .f1 {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      a {
        font-size: 12px;
        color: #888;
        margin: 10px 15px;
      }
    }
  }
}
</style>
